module.exports = __webpack_public_path__ + "img/logo.ab773d36.svg";